import {BaseAttribute} from "@/pages/AppPages/Events/attribute";
import {required} from "vuelidate/lib/validators";

export class CatchingEventAttributes extends BaseAttribute {

    constructor(initObjectParams) {
        super(initObjectParams);

        this.address = null;
        this.addressHumanReadable = null;
        this.addressObject = {};
        this.immobilizationType = null;
        this.distinctive = null;
        this.report = null;
        this.raid = null;
        this.lat = null;
        this.lon = null;

        if (initObjectParams && initObjectParams.hasOwnProperty('raid')) {
            this.raid = initObjectParams['raid'];
            this.address = this.raid.address;
            this.addressHumanReadable = this.raid.addressHumanReadable;
            this.addressObject = this.raid.addressObject;
            this.lat = this.raid.lat;
            this.lon = this.raid.lon;
        }
    }

    static get modelName() {
        return 'CatchingEvent'
    }

    static get validations() {
        return {
            address: { required },
            immobilizationType: {},
            distinctive: {},
            report: {},
            lat: {},
            lon: {}
        }
    }

    static get validationFieldLabels() {
        return {
            address: 'Фактический адрес',
            immobilizationType: 'Способ обездвиживания',
            distinctive: 'Особые приметы',
            report: 'Комментарий',
        }
    }

    static get mapping() {
        return {}
    }

    static get label() {
        return ''
    }

    static get newLabel() {
        return ''
    }

    objectLabel() {
        return ''
    }

    get coordinates() {
        return { lat: this.lat, lon: this.lon }
    }

    applyData(data) {
        this.immobilizationType = data['immobilizationType'];
        this.distinctive = data['distinctive'];
        this.report = data['report'];
        this.address = data['address'];
        this.addressObject = data['address_object'];
        this.lat = data['lat'];
        this.lon = data['lon'];
    }

}